import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const workSteps = [
  {
    icon: 'work-icon-01.svg',
    title: 'Step 1 · Requirement Discovery',
    desc: 'We collaborate with key stakeholders to gather goals, workflows, and system requirements.',
  },
  {
    icon: 'work-icon-02.svg',
    title: 'Step 2 · Solution Architecture',
    desc: 'Our architects design scalable system structures, data models, and tech stacks.',
  },
  {
    icon: 'work-icon-03.svg',
    title: 'Step 3 · Agile Development',
    desc: 'Using SCRUM, we build features in sprints with regular reviews and incremental progress.',
  },
  {
    icon: 'work-icon-04.svg',
    title: 'Step 4 · Testing & Deployment',
    desc: 'We conduct unit, integration, and load tests before deploying in a cloud or on-prem environment.',
  },
  {
    icon: 'work-icon-05.svg',
    title: 'Step 5 · Support & Iteration',
    desc: 'After launch, we provide monitoring, support, and enhancements based on usage data.',
  },
];

const faqItems = [
  {
    question: "What kind of software projects do you develop?",
    answer:
      "We develop custom software solutions including CRMs, ERPs, SaaS platforms, internal dashboards, automation tools, and specialized business apps across various industries.",
  },
  {
    question: "Do you work with legacy systems or re-engineering?",
    answer:
      "Yes. We modernize outdated systems, migrate them to modern architectures, and optimize performance while preserving critical functionality.",
  },
  {
    question: "Which technologies do you use for backend and frontend?",
    answer:
      "We work with JavaScript (Node.js, React, Vue), Python (Django, FastAPI), PHP (Laravel), and .NET, among others. Tech stack is chosen based on project needs.",
  },
  {
    question: "How do you ensure software quality and security?",
    answer:
      "We follow strict SDLC best practices with version control, automated tests, code reviews, and security checks integrated into the pipeline.",
  },
];


const ServicesOffered = () => {
  useEffect(() => {
    if (window.WOW) new window.WOW().init();
    if (window.initMagnetic) window.initMagnetic();
  }, []);

  return (
    <>
      {/* Start breadcrumbs section */}
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-wrapper">
                <div className="breadcrumb-cnt">
                  <span>Services Details</span>
                  <h1>Software Applications</h1>
                  <div className="breadcrumb-list">
                    <Link to="/">Home</Link>
                    <img src="/assets/img/content/breadcrumb-arrow.svg" alt="" />
                    Services Details
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="service-details">
        <div className="about-services sec-mar">
          <div className="container">
            <div className="row gy-5">
              <div className="col-lg-6 d-flex align-items-center wow animate fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="about-content">
                  <div className="section-title-5">
                    <h2>Software <br /> Applications</h2>
                  </div>
                  <p>
                    Our Software Development services empower businesses to build tailored digital solutions that solve real-world problems. From enterprise-grade platforms to specialized internal tools, we engineer software that aligns with your strategy, scales with your growth, and transforms operations. With a focus on performance, maintainability, and security, we deliver solutions that stand the test of time.
                  </p>
                  <ul className="about-featue">
                    <li><svg width="15" height="15"><circle cx="7" cy="7" r="7" fill="#c79528" /></svg> Custom Software Solutions</li>
                    <li><svg width="15" height="15"><circle cx="7" cy="7" r="7" fill="#c79528" /></svg> ERP & CRM Development</li>
                    <li><svg width="15" height="15"><circle cx="7" cy="7" r="7" fill="#c79528" /></svg> Legacy Software Modernization</li>
                    <li><svg width="15" height="15"><circle cx="7" cy="7" r="7" fill="#c79528" /></svg> Cloud-Native Applications</li>
                    <li><svg width="15" height="15"><circle cx="7" cy="7" r="7" fill="#c79528" /></svg> Business Process Automation</li>
                    <li><svg width="15" height="15"><circle cx="7" cy="7" r="7" fill="#c79528" /></svg> Ongoing Maintenance & Optimization</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 wow animate fadeInRight" data-wow-delay="300ms" data-wow-duration="1500ms">
                <div className="service-img magnetic-item">
                  <img className="img-fluid" src="/assets/img/services/laptop.png" alt="Service" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="how-we-work-section sec-mar">
          <div className="container">
            <div className="row mb-60 wow animate fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>How We Work</h2>
                </div>
              </div>
            </div>
          </div>

          <div className="work-item">
            <div className="container-fluid">
              <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 gy-5 justify-content-center">
                {workSteps.map((step, idx) => (
                  <div
                    key={step.title}
                    className="col magnetic-item wow animate fadeInUp"
                    data-wow-delay={`${200 + idx * 100}ms`}
                    data-wow-duration="1500ms"
                  >
                    <div className="single-work">
                      <div className="work-icon">
                        <img src={`/assets/img/content/${step.icon}`} alt="" />
                      </div>
                      <div className="work-content">
                        <h3>{step.title}</h3>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="service-sort-driscription-area sec-mar">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 wow animate fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="driscription-img magnetic-item">
                  <img className="img-fluid" src="/assets/img/services/rectangular_image.png" alt="Description" />
                </div>
              </div>
              <div className="driscription-content">
                <div className="row">
                  <div
                    className="col-md-6 wow animate fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    <p>
                      We build software that drives business impact. Using modular architecture and scalable design patterns, we ensure your platform grows seamlessly as your user base and business needs evolve. Our teams work hand-in-hand with your stakeholders to deliver precise, goal-driven software on time and within budget.
                    </p>
                  </div>

                  <div
                    className="col-md-6 wow animate fadeInUp"
                    data-wow-delay="300ms"
                    data-wow-duration="1500ms"
                  >
                    <p>
                      Whether you’re digitizing manual workflows, connecting systems with powerful APIs, or building from scratch—we bring technical excellence and strategic thinking to every project. The outcome? Software that works for people and performs under pressure.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-faq-area sec-mar">
          <div className="container">
            <div className="row gy-5">
              <div className="col-lg-6 wow animate fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="faq-img magnetic-item">
                  <img className="img-fluid" src="/assets/img/services/faqs.png" alt="FAQ" />
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center wow animate fadeInRight" data-wow-delay="300ms" data-wow-duration="1500ms">
                <div className="faq-content-area">
                  <h2>We Are Working With Creative User.</h2>
                    <div className="accordion" id="accordionExample">
                      {faqItems.map((item, index) => (
                        <div key={index} className="accordion-item">
                          <h6 className="accordion-header" id={`heading${index}`}>
                            <button
                              className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${index}`}
                              aria-expanded={index === 0 ? 'true' : 'false'}
                              aria-controls={`collapse${index}`}
                            >
                              {item.question}
                            </button>
                          </h6>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`heading${index}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              {item.answer}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicesOffered;



